module.exports = __webpack_public_path__ + "static/10-bff7c4b60e5979ec053b36e51d969f1c.jpeg";